import { SearchBox } from "./SearchBox";
import { useLocation, useNavigate } from "react-router-dom";
import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import TicketIcon from "../../../../assets/VZY/tickets.png";

export const Search = ({ isScrolled }) => {
  const apiBaseURL = process.env.REACT_APP_API_URL || window.location.origin;
  const navigation = useNavigate();
  const location = useLocation();
  const [tickets, setTickets] = useState([]);

  const fetchTicketList = useCallback(async () => {
    try {
      const payload = {
        OttSMSId:
          JSON.parse(sessionStorage.getItem("helpSupportData") || "{}").sid ||
          "",
      };

      const response = await axios.post(
        `${apiBaseURL}/api/v1/ContactUs/vzy-complain`,
        payload,
        { headers: { "Content-Type": "application/json" } },
      );
      const apiData = response?.data?.data || [];

      setTickets(apiData);
    } catch (err) {
      console.error("fetchTicketList error:", err);
    } finally {
    }
  }, [apiBaseURL]);

  useEffect(() => {
    fetchTicketList();
  }, [fetchTicketList]);

  return (
    <>
      {isScrolled ? (
        <div className="search-wrapper">
          <div className="container">
            <div className="page-scroll-search-wrapper">
              <div className="search-scroll-row">
                <SearchBox />
              </div>
              <form className="form-inline d-flex align-items-center">
                {/* <label className="mr-2 mb-0">Language</label>
                <select className="form-control-language" disabled>
                  <option value="">Select</option>
                  <option value="en" selected>
                    English
                  </option>
                  <option value="hi">हिंदी</option>
                      <option value="ta">தமிழ்</option>
                      <option value="ta">বাংলা</option>
                      <option value="ta">తెలుగు</option>
                </select> */}
                {!location.pathname.startsWith("/VZYSupport/MyTickets") &&
                  tickets.length > 0 && (
                    <span
                      className="my-ticket-btn"
                      onClick={() => navigation("/VZYSupport/MyTickets")}
                    >
                      <img src={TicketIcon} alt="My Tickets" />
                      My Tickets
                    </span>
                  )}
              </form>
            </div>
          </div>
        </div>
      ) : (
        <div className="search-wrapper">
          <div className="container">
            <h1>What can we help you with today ?</h1>
            <div className="search-row">
              <SearchBox />
            </div>
          </div>
        </div>
      )}
    </>
  );
};
